
import React from "react";

const AudienceSection: React.FC = () => {
  return (
    <section className="section-container relative overflow-hidden" id="audience">
      <div className="absolute inset-0 particles-container">
        {[...Array(15)].map((_, i) => (
          <span 
            key={i} 
            className="particle" 
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 5}s`,
              width: `${Math.random() * 3 + 1}px`,
              height: `${Math.random() * 3 + 1}px`,
            }}
          />
        ))}
      </div>
      
      <h2 className="text-3xl md:text-4xl font-bold mb-16 text-center relative z-10">
        Nem todo mundo vai aguentar. E tá tudo bem.
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-16 relative z-10">
        <div className="scroll-reveal">
          <h3 className="text-2xl font-bold mb-8">É pra você se:</h3>
          <ul className="space-y-6">
            <li className="flex items-start">
              <span className="mr-3 text-xl">•</span>
              <span>Você sente que está se tornando uma cópia — mesmo fingindo originalidade</span>
            </li>
            <li className="flex items-start">
              <span className="mr-3 text-xl">•</span>
              <span>Você treina o corpo, mas ainda se sente fraco por dentro</span>
            </li>
            <li className="flex items-start">
              <span className="mr-3 text-xl">•</span>
              <span>Você busca ser independente, livre e presente</span>
            </li>
          </ul>
        </div>
        <div className="scroll-reveal">
          <h3 className="text-2xl font-bold mb-8">Não é pra você se:</h3>
          <ul className="space-y-6">
            <li className="flex items-start">
              <span className="mr-3 text-xl">•</span>
              <span>Você quer fórmula mágica</span>
            </li>
            <li className="flex items-start">
              <span className="mr-3 text-xl">•</span>
              <span>Você precisa que alguém te lembre todo dia que você é capaz</span>
            </li>
            <li className="flex items-start">
              <span className="mr-3 text-xl">•</span>
              <span>Você ainda acredita que o problema é o governo, o tempo, a genética</span>
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default AudienceSection;
